/* eslint-disable react/jsx-no-useless-fragment */
import { FontAwesomeIcon, Icon } from "assets/icons";
import CreateButton from "components/CreateButton";
import FormInput from "components/FormInput";
import { INPUT_TYPE } from "config/constants";
import { t } from "i18next";
import { useHistory } from "react-router-dom";
import FilterMenuDate from "../FilterMenuDate";
import { FiltersTag } from "../FiltersTag";
import "./index.scss";

function Toolbar({
  params,
  handleSearch,
  sellersOptions,
  handleRemoveFilterTag,
  filterTags,
  setParams,
  setFilterTags,
  optionOwnerType,
  optionStatus,
  staffs,
  statusTabs,
  setSizeScrollPageAll,
  setSelectedRow,
  searchTerm,
  sellerFilterOptions,
}) {
  const history = useHistory();

  return (
    <div className="toolbar-recommend-import">
      <div className="toolbar-box">
        <div style={{ display: "flex", gap: "20px" }}>
          <FilterMenuDate
            params={params}
            setParams={setParams}
            staffs={sellersOptions}
            filterTags={filterTags}
            setFilterTags={setFilterTags}
            setSizeScrollPageAll={setSizeScrollPageAll}
            setSelectedRow={setSelectedRow}
            filterKey="startDate"
            fromQueryKey="startDateFrom"
            toQueryKey="startDateTo"
            buttonLabel="Ngày ký"
          />
          <FilterMenuDate
            params={params}
            setParams={setParams}
            staffs={sellersOptions}
            filterTags={filterTags}
            setFilterTags={setFilterTags}
            setSizeScrollPageAll={setSizeScrollPageAll}
            setSelectedRow={setSelectedRow}
            filterKey="endDate"
            fromQueryKey="endDateFrom"
            toQueryKey="endDateTo"
            buttonLabel="Ngày hết hạn"
          />
          <div className="search-input">
            <FormInput
              {...{
                type: INPUT_TYPE,
                inputOptions: {
                  value: searchTerm,
                  onChange: handleSearch,
                  placeholder: t("Tìm kiếm theo mã hợp đồng"),
                  prefix: <FontAwesomeIcon icon={Icon.faSearch} />,
                },
              }}
            ></FormInput>
          </div>
        </div>

        <CreateButton
          title="Thêm hợp đồng"
          className="btn-create"
          onClick={() => {
            history.push({
              pathname: "/contract/create",
            });
          }}
        />
      </div>
      <div style={{ marginTop: "10px" }}>
        <FiltersTag
          rangeDateTimeFilter={params?.filters?.startDate || []}
          expiryDateTimeFilter={params?.filters?.endDate || []}
          params={params}
          handleRemoveFilterTag={handleRemoveFilterTag}
          optionOwnerType={optionOwnerType}
          optionStatus={optionStatus}
          staffs={staffs}
          sellersOptions={sellersOptions}
          statusTabs={statusTabs}
          sellerFilterOptions={sellerFilterOptions}
        />
      </div>
    </div>
  );
}

export default Toolbar;
